import { useNavigate } from "react-router-dom";

import { useEffect, useMemo, useState } from "react";

import ContentCard from "../../../components/misc/ContentCard";
import CustomButton from "../../../components/CustomButton";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";

import useRoutesHelper from "../../../hooks/useRoutesHelper";

import {
  fetchUserDetails,
  postUserRolesAndNodes,
} from "../../../redux/api/admin.api";
import {
  checkEndpointStatus,
  endpointStatus,
} from "../../../helpers/apiHelper";
import Dropdown, { DropdownValue } from "../../../components/misc/Dropdown";
import { getWorkingRoutesNodes } from "../../../redux/api/expedition.api";

const userFunctionsDropdownValue = [
  { id: 10, label: "Livrator" },
  { id: 11, label: "Sofer internod" },
  { id: 20, label: "Sofer backup" },
  { id: 12, label: "Manager nod (ierarhic direct pentru livratori si soferi)" },
  { id: 13, label: "Dispecer logistica" },
  { id: 14, label: "Manager logistica (ierarhic direct pt manager nod)" },
  { id: 15, label: "Persoana responsabila farmacie" },
  { id: 16, label: "Manager general" },
  { id: 77, label: "Superuser" },
];

function RolesAndNodes() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { routeParams } = useRoutesHelper();

  const userId = routeParams.userId;

  const {
    admin: {
      user: { data: userDetailsData, isLoading: isLoadingUser },
    },
    expedition: {
      workingRoutesNodes: {
        data: { data: userAllNodes },
      },
    },
  } = useAppSelector((state) => ({
    admin: state.admin,
    expedition: state.expedition,
  }));

  const [isLoading, setIsLoading] = useState(false);
  const [selectedUserFunction, setSelectedUserFunction] =
    useState<DropdownValue | null>(null);
  const [selectedUserNode, setSelectedUserNode] =
    useState<DropdownValue | null>(null);

  useEffect(() => {
    if (userId) {
      dispatch(fetchUserDetails(userId));
    }
  }, [dispatch, userId]);

  useEffect(() => {
    dispatch(
      getWorkingRoutesNodes({
        page: 1,
        perPage: 1000,
      }),
    );
  }, [dispatch]);

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleSaveProductDetails = async (e: any) => {
    e.preventDefault();

    if (!selectedUserFunction?.id || !selectedUserNode?.id) {
      return;
    }
    setIsLoading(true);

    const resultAction = await dispatch(
      postUserRolesAndNodes({
        userId,
        userFunction: selectedUserFunction?.id,
        node: selectedUserNode.id,
      }),
    );

    if (
      checkEndpointStatus(resultAction, postUserRolesAndNodes) !==
      endpointStatus.pending
    ) {
      setIsLoading(false);
    }

    if (
      checkEndpointStatus(resultAction, postUserRolesAndNodes) ===
      endpointStatus.fulfilled
    ) {
      navigate(-1);
    }
  };
  const userAllNodesNew = useMemo(
    () =>
      userAllNodes.map((item) => {
        return {
          id: item.id_nod,
          label: item.nodNume,
        };
      }),
    [userAllNodes],
  );
  useEffect(() => {
    if (userDetailsData) {
      const currentUserFunction = userFunctionsDropdownValue.find(
        (userFunction) => userFunction.id === userDetailsData.user_role,
      );
      setSelectedUserFunction(currentUserFunction || null);

      const currentUserNode = userAllNodesNew.find(
        (userNode) => userNode.id === userDetailsData.user_dept,
      );

      setSelectedUserNode(currentUserNode || null);
    }
  }, [userAllNodesNew, userDetailsData]);

  const customCardTitle =
    userDetailsData?.nume &&
    `Editeaza locatia si functia pentru utilizatorul: ${userDetailsData?.nume} ${userDetailsData?.prenume}`;

  return (
    <ContentCard cardTitle={customCardTitle} isLoading={isLoadingUser}>
      <form
        className="w-full"
        onSubmit={handleSaveProductDetails}
        noValidate
        id="kt_login_signin_form">
        <Dropdown
          className="mb-4 mr-2"
          title="Selecteaza functia"
          data={userFunctionsDropdownValue}
          singleValue={selectedUserFunction}
          setSingleValue={(value) => {
            setSelectedUserFunction(value);
          }}
        />

        <Dropdown
          className="my-4"
          title="Selecteaza nod"
          data={userAllNodesNew}
          singleValue={selectedUserNode}
          setSingleValue={(value) => {
            setSelectedUserNode(value);
          }}
        />

        <div className="flex justify-between">
          <CustomButton variant="outlined" onClick={handleGoBack}>
            Anuleaza
          </CustomButton>
          <CustomButton
            type="submit"
            variant="contained"
            loading={isLoading}
            disabled={!selectedUserFunction || !selectedUserNode}>
            Salveaza
          </CustomButton>
        </div>
      </form>
    </ContentCard>
  );
}

export default RolesAndNodes;
